export function StatCard({ label, value, icon: Icon, accent = false, sub, delay = 0, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`sg-fade-up group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#141414] p-6 transition-transform duration-300 ease-out hover:-translate-y-1 ${onClick ? "cursor-pointer" : ""}`}
      style={{ animationDelay: `${delay}ms` }}
      data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-neutral-500">{label}</p>
        {Icon && (
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              accent ? "bg-[#E30613]/15 text-[#FF1C2A]" : "bg-white/[0.05] text-neutral-400"
            }`}
          >
            <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
          </span>
        )}
      </div>
      <p className="mt-5 font-display text-4xl font-semibold tracking-tight text-white">{value}</p>
      {sub && <p className="mt-1 text-sm text-neutral-500">{sub}</p>}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[2px] scale-x-0 bg-gradient-to-r from-transparent via-[#E30613] to-transparent transition-transform duration-300 group-hover:scale-x-100" />
    </div>
  );
}
